/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для кнопки прокрутки страницы вверх (back to top)
   */
  app.ToTopView = app.View.extend({
    el: '.totop',

    events: {
      'click': 'toTop',
    },
    additionalOptions: ['mainWindow'],
    /**
     * @inheritDoc
     */
    run: function () {
      this.$window = this.mainWindow.$el;
  
      // При прокрутке страницы:
      this.listenTo(this.mainWindow, 'window.scroll', _.throttle(function () {
        this.windowHeight = this.$window.height();
        this.showHideButton();
        this.stickToFooter();
      }.bind(this), 100, {leading: true}));
    },
    /**
     * Прокрутка в верх экрана
     */
    toTop: function () {
      $('html,body').animate({scrollTop: 0}, 'slow');
    },
    /**
     * Прячет или показывает кнопку в зависимости от высоты окна
     */
    showHideButton: function () {
      // Показываем кнопку только после прокрутки полного экрана
      if (this.$window.scrollTop() <= this.windowHeight) {
        this.$el.fadeOut(1000);
      } else {
        this.$el.fadeIn(1000);
      }
    },
    /**
     * Прикрепляет кнопку к футеру, если доскроллили до него
     */
    stickToFooter: function () {
      var documentHeight = $(document).height(),
        windowHeight = this.windowHeight,
        limit = $('.js-totop-limit'),
        bottomLimit = limit.length ? limit.offset().top : 0,
        totopLimitHeight = documentHeight - bottomLimit;

      // Чтобы кнопка не заходила на футер
      if ((documentHeight - this.$window.scrollTop()) <= (windowHeight + totopLimitHeight)) {
        this.$el.css({position: 'absolute', bottom: totopLimitHeight + 'px'});
      } else {
        this.$el.css({position: 'fixed', bottom: '0px'});
      }
    },
  });
})(jQuery);

}.call(window));